import { useFeatureValue } from "@growthbook/growthbook-react";
import config, { SCANNER_FLAG } from "config/config";
import { ScannerType } from "models/scanner-type";

// Single decision point for which scanner to use. Today it's driven purely by
// the Growthbook A/B flag (`SCANNER_FLAG`, a value flag returning a scanner id);
// anything not in this build's enabled set falls back to the default (control)
// scanner. Future per-document / destination / risk routing plugs in here.
const useScannerSelection = (): ScannerType => {
  const value = useFeatureValue<string>(SCANNER_FLAG, config.defaultScanner);

  const selected = ScannerType[value as keyof typeof ScannerType];
  if (selected && config.enabledScanners.includes(selected)) {
    return selected;
  }

  return config.defaultScanner;
};

export default useScannerSelection;
